import { extractErrorCode } from './errors.ts'

export class ApiError extends Error {
  status: number
  code: string
  constructor(status: number, code: string, message?: string) {
    super(message || code)
    this.status = status
    this.code = code
  }
}

export async function requestJSON<T>(
  path: string,
  options: RequestInit & { token?: string; apiBase?: string } = {},
): Promise<T> {
  const headers = new Headers(options.headers)
  if (!headers.has('Content-Type') && options.body) {
    headers.set('Content-Type', 'application/json')
  }
  if (options.token) {
    headers.set('Authorization', `Bearer ${options.token}`)
  }
  const base = options.apiBase ?? ''
  const res = await fetch(`${base}${path}`, { ...options, headers })
  if (!res.ok) {
    let code = 'request_failed'
    let msg = res.statusText
    try {
      const body = await res.json()
      code = extractErrorCode(body)
      msg = (body as { message?: string }).message || msg
    } catch {
      /* ignore */
    }
    throw new ApiError(res.status, code, msg)
  }
  if (res.status === 204) return undefined as T
  return (await res.json()) as T
}
